


























































































































import { apiMallTopStoreGetStoreList } from '@/api'
import { AsyncReturnType } from 'vtils/types'
import { computed, ref } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent } from '@/hooks'
import { navigateTo } from '@/router'
import { Track } from '@/utils'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '同城配送商家列表',
        }))
      }

      loading = computed(() => false)

      filterIndex = ref(0)

      absFilterIndex = computed(() => Math.abs(this.filterIndex.value))

      handleDataLoad = async ({ pageNumber }: any) => {
        const { longitude, latitude } = await dcb
          .getLocation()
          .catch(() => ({} as AsyncReturnType<typeof dcb.getLocation>))
        return apiMallTopStoreGetStoreList({
          latitude: latitude || ('' as any),
          longitude: longitude || ('' as any),
          pageIndex: pageNumber,
          pageSize: 10,
          sortType:
            this.absFilterIndex.value === 1
              ? 2
              : this.absFilterIndex.value === 2
              ? 3
              : 1,
          desc: this.filterIndex.value < 0,
          storeType: 3,
        })
      }

      handleMartClick = (martId: string) => {
        navigateTo('InstantDeliveryMartIndex', { martId })
      }
    },
)
